import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import MetricsCards from './MetricsCards';
import AIInsights from './AIInsights';
import AnalyticsCharts from './AnalyticsCharts';
import SocialIntegration from './SocialIntegration';
import ContentPerformance from './ContentPerformance';
import AudienceAnalytics from './AudienceAnalytics';
import AIRecommendations from './AIRecommendations';
import ActivityFeed from './ActivityFeed';
import QuickActions from './QuickActions';

const Dashboard: React.FC = () => {
  return (
    <>
      {/* Hero Dashboard Section */}
      <section id="hero-dashboard" className="mb-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-6 space-y-4 md:space-y-0">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">Dashboard</h1>
            <p className="text-gray-400 text-sm md:text-base">Sosyal medya performansınızı tek yerden takip edin</p>
          </div>
          <button className="flex items-center justify-center space-x-2 bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg transition-colors w-full md:w-auto">
            <FontAwesomeIcon icon={faDownload} />
            <span className="hidden md:inline">Rapor İndir</span>
          </button>
        </div>
      </section>

      {/* Metrics Cards */}
      <MetricsCards />

      {/* AI Insights */}
      <AIInsights />

      {/* Analytics Charts */}
      <AnalyticsCharts />

      {/* Social Integration */}
      <SocialIntegration />

      {/* Content Performance */}
      <ContentPerformance />

      {/* Audience Analytics */}
      <AudienceAnalytics />

      {/* AI Recommendations */}
      <AIRecommendations />

      {/* Activity Feed */}
      <ActivityFeed />

      {/* Quick Actions */}
      <QuickActions />
    </>
  );
};

export default Dashboard;
